import gql from 'graphql-tag';
import { FetchResult } from '@apollo/client';

import { GetEicMessageInput, GetEicMessageResponse } from '@buy-viasat/types/build/bv';
import { client } from 'shared/containers/apollo';

export type GetEicMessagesResponse = FetchResult<{ getEicMessages: GetEicMessageResponse }>;

const GET_EIC_MESSAGES = gql`
  query getEicMessages($input: GetEicMessageInput!) {
    getEicMessages(input: $input) {
      productTypeId
      eicMessage
      productCandidateId
    }
  }
`;

export default async function getEicMessagesAsync({
  input,
}: {
  input: GetEicMessageInput;
}): Promise<GetEicMessagesResponse> {
  const response = client.query({
    query: GET_EIC_MESSAGES,
    variables: { input },
    fetchPolicy: 'no-cache',
  });
  return response;
}
